import CNPJValidate from './rules/cnpj';

const validator = {
	getMessage() { // field, args
		return 'Invalid CNPJ';
	},
	validate(value) { // args
		return CNPJValidate(value);
	}
};

export default validator;



// WEBPACK FOOTER //
// ./sources/support/validator/cnpj.validator.js